import { Injectable } from "@angular/core";

@Injectable()
export class SidenavbarViewService {

    childView: string;

    constructor() {}

}